import Breadcrumb from "components/Common/Breadcrumb"
import Loader from "components/Loader/loader"
import React, { useEffect, useState } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Table,
} from "reactstrap"

import { Switch } from "antd"
import Swal from "sweetalert2"

import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import { FaPen } from "react-icons/fa"
import { MdDelete } from "react-icons/md"
import moment from "moment"
import {
  fetchData,
  FetchDeleteData,
  FetchPostData,
  FetchPutData,
} from "utils/Common_api_functions"

const HRSection = () => {
  const [loading, setLoading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const [policies, setPolicies] = useState([])
  const [editId, setEditId] = useState(null)

  const [policyTitle, setPolicyTitle] = useState("")
  const [policyContent, setPolicyContent] = useState("")

  const toggleModal = () => setIsModalOpen(!isModalOpen)

  useEffect(() => {
    fetchPolicy()
  }, [])

  const fetchPolicy = async () => {
    const APIdata = await fetchData(setLoading, "compliance")
    if (APIdata?.success) {
      setPolicies(APIdata?.data)
    } else {
      Swal.fire({
        title: "Something Went Wrong",
        text: APIdata?.data?.message || APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  /* ---------------- ADD / EDIT ---------------- */
  const handleSavePolicy = async () => {
    if (!policyTitle.trim() || !policyContent.trim()) return

    if (editId) {
      const APIdata = await FetchPutData(setLoading, "compliance", editId, {
        title: policyTitle,
        termsAndConditions: policyContent,
      })
      if (APIdata?.data?.success) {
        Swal.fire({
          title: "HR Policy Updated SuccessFully.",
          text: APIdata?.data?.message,
          icon: "success",
        })
        fetchPolicy()
      } else {
        Swal.fire({
          title: "Something Went Wrong",
          text: APIdata?.data?.message || APIdata?.response?.data?.message,
          icon: "error",
        })
      }
    } else {
      const APIdata = await FetchPostData(setLoading, "compliance", {
        title: policyTitle,
        termsAndConditions: policyContent,
      })
      if (APIdata?.data?.success) {
        Swal.fire({
          title: "HR Policy Saved SuccessFully.",
          text: APIdata?.data?.message,
          icon: "success",
        })
        fetchPolicy()
      } else {
        Swal.fire({
          title: "Something Went Wrong",
          text: APIdata?.data?.message || APIdata?.response?.data?.message,
          icon: "error",
        })
      }
    }

    resetForm()
  }

  const resetForm = () => {
    setPolicyTitle("")
    setPolicyContent("")
    setEditId(null)
    toggleModal()
  }

  /* ---------------- EDIT ---------------- */
  const handleEdit = item => {
    setPolicyTitle(item.title)
    setPolicyContent(item.termsAndConditions)
    setEditId(item.id)
    setIsModalOpen(true)
  }

  /* ---------------- STATUS ---------------- */
  const handleStatusChange = async (checked, id) => {
    Swal.fire({
      title: "Are you Sure",
      text: "You want to Update Status of This Policy!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then(async result => {
      if (result.isConfirmed) {
        const APIdata = await FetchPutData(setLoading, "compliance", id, {
          status: checked,
        })
        if (APIdata?.data?.success) {
          Swal.fire({
            title: "HR Policy Updated SuccessFully.",
            text: APIdata?.data?.message,
            icon: "success",
          })
          fetchPolicy()
        } else {
          Swal.fire({
            title: "Something Went Wrong",
            text: APIdata?.data?.message || APIdata?.response?.data?.message,
            icon: "error",
          })
        }
      }
    })
  }

  /* ---------------- DELETE ---------------- */
  const handleDelete = id => {
    Swal.fire({
      title: "Delete this policy?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then(async result => {
      if (result.isConfirmed) {
        const APIdata = await FetchDeleteData(setLoading, "compliance", id)
        if (APIdata?.data?.success) {
          Swal.fire({
            title: "HR Policy Deleted SuccessFully.",
            text: APIdata?.data?.message,
            icon: "success",
          })
          fetchPolicy()
        } else {
          Swal.fire({
            title: "Something Went Wrong",
            text: APIdata?.data?.message || APIdata?.response?.data?.message,
            icon: "error",
          })
        }
      }
    })
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb
          title="Dashboard"
          breadcrumbItem="HR & Compliance"
          description="Manage all HR policies from here"
        />

        {loading && <Loader />}

        <Row>
          <Col lg="12" className="px-0">
            <Card className="shadow-lg">
              <CardBody>
                <div className="d-flex justify-content-end mb-3">
                  <Button color="primary" onClick={() => setIsModalOpen(true)}>
                    + Add Policy
                  </Button>
                </div>

                <Table bordered responsive hover>
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: "5%" }}>#</th>
                      <th>Policy Title</th>
                      <th>Creation Date</th>
                      <th style={{ width: "15%" }}>Status</th>
                      <th style={{ width: "20%" }}>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {policies.length === 0 ? (
                      <tr>
                        <td colSpan="5" className="text-center text-muted">
                          No policies added yet
                        </td>
                      </tr>
                    ) : (
                      policies.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item.title}</td>
                          <td>
                            {moment(item.createdAt)?.format(
                              "DD/MM/YYYY, hh:mm A"
                            )}
                          </td>
                          <td>
                            <Switch
                              checked={item.status}
                              onChange={checked =>
                                handleStatusChange(checked, item.id)
                              }
                            />
                          </td>
                          <td>
                            <Button
                              color="warning"
                              size="sm"
                              className="me-2"
                              onClick={() => handleEdit(item)}
                            >
                              <FaPen />
                            </Button>
                            <Button
                              color="danger"
                              size="sm"
                              onClick={() => handleDelete(item.id)}
                            >
                              <MdDelete />
                            </Button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* ---------------- MODAL ---------------- */}
      <Modal isOpen={isModalOpen} toggle={toggleModal} size="lg" centered>
        <ModalHeader toggle={toggleModal}>
          {editId ? "Edit Policy" : "Add Policy"}
        </ModalHeader>

        <ModalBody>
          <div className="mb-3">
            <label className="form-label">Policy Title</label>
            <Input
              placeholder="Enter policy title"
              value={policyTitle}
              onChange={e => setPolicyTitle(e.target.value)}
            />
          </div>

          <div>
            <label className="form-label">Policy Details</label>
            <CKEditor
              editor={ClassicEditor}
              data={policyContent}
              onChange={(event, editor) => setPolicyContent(editor.getData())}
            />
          </div>
        </ModalBody>

        <ModalFooter className="text-start">
          <Button color="primary" onClick={handleSavePolicy}>
            {editId ? "Update Policy" : "Save Policy"}
          </Button>
          <Button color="secondary" onClick={resetForm}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default HRSection
